module.exports = __webpack_public_path__ + "img/newsletter.42354faf.png";